var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavoriteIcon = function SvgFavoriteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#213D38",
    strokeWidth: 1.4,
    d: "M11.98 19.739a.49.49 0 0 1-.626 0l-1.065-.89c-4.892-4.072-8.122-6.766-8.122-10.053C2.167 6.1 4.465 4 7.392 4c1.652 0 3.239.706 4.274 1.814C12.702 4.706 14.29 4 15.942 4c2.926 0 5.225 2.101 5.225 4.796 0 3.287-3.23 5.981-8.122 10.053z"
  })));
};
export default SvgFavoriteIcon;